@if (selectedTerm) {
    <div class="mf-telm-chat">
        <div #scrollMe class="mf-chat-container pl-2 pr-2">
            @if (!isLoaded) {
                <div class="m-loader m-loader--brand pb-5 text-center"></div>
            }
            @for (item of chatData; track item; let last = $last) {
                <div #chatList class="mf-chat-bubble-container">
                    <div class="mf-chat-time" [ngClass]="item.source === 'DOCTOR' ? 'text-right' : ''">
                        <div class="text-center">{{ item.eventTime | date: 'short' }}</div>
                        @if (item.source === 'PATIENT') {
                            <div class="small">
                                {{ selectedTerm?.customer?.name }}
                                {{ selectedTerm?.customer?.surname }}
                            </div>
                        }
                        @if (item.source === 'DOCTOR') {
                            <div class="small text-right">
                                {{ subcontractor?.academicTitle }} {{ subcontractor?.name }}, {{ subcontractor?.education }}
                            </div>
                        }
                    </div>
                    @if (item?.chat) {
                        <div class="mf-chat-bubble" [ngClass]="item.source === 'DOCTOR' ? 'mf-chat-client' : 'mf-chat-server'">
                            {{ item.chat }}
                        </div>
                    }
                    @if (item?.document) {
                        <div class="mf-chat-bubble mf-chat-bubble--hover" [ngClass]="item.source === 'DOCTOR' ? 'mf-chat-client' : 'mf-chat-server'">
                            @if (item.source !== 'DOCTOR') {
                                <div class="d-flex justify-content-end">
                                    <span
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        ngbTooltip="Upravljanje z dokumentom"
                                        container="body"
                                        placement="top"
                                    >
                                        <a><i class="la la-ellipsis-v"></i></a>
                                        <div class="dropdown-menu">
                                            <div (click)="deleteDocumentFromChat(item?.document)" class="dropdown-item dropDownItem">Zbriši</div>
                                            <div (click)="saveDocumentToCustomer(item?.document)" class="dropdown-item dropDownItem">
                                                Shrani na stranko
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            }
                            <span (click)="openDocument(item?.document)">
                                <i class="mf-document-icon la la-file"></i>
                                <div>{{ item?.document?.fileName }}</div>
                            </span>
                        </div>
                    }
                </div>
            }
        </div>
        <div class="mf-chat-controls">
            @if (this.chatForm) {
                <form [formGroup]="chatForm" (submit)="sendMessage()" novalidate>
                    <div class="mf-chat-message d-flex py-2">
                        <div class="mr-2">
                            <button
                                (click)="upload()"
                                ngbTooltip="Naloži datoteko"
                                type="button"
                                class="btn m-btn m-btn-success m-btn--hover-success m-btn--icon m-btn--icon-only m-btn--pill"
                            >
                                <i class="la la-upload"></i>
                            </button>
                        </div>
                        <div class="mf-chat-form w-100">
                            <input placeholder="Natipkajte sporočilo stranki..." type="text" formControlName="message" class="form-control" />
                        </div>
                        <div class="ml-2">
                            <button
                                ngbTooltip="Pošlji sporočilo"
                                data-testid="send-message-button"
                                type="submit"
                                class="btn m-btn m-btn-success m-btn--hover-success m-btn--icon m-btn--icon-only m-btn--pill"
                            >
                                <i class="la la-send-o"></i>
                            </button>
                        </div>
                    </div>
                    <div [hidden]="chatForm?.value?.uploadFile?.length < 1" class="w-100">
                        <file-upload
                            #fileUploadComponent
                            formControlName="uploadFile"
                            animation="true"
                            accept="file_extension|audio/*|video/*|image/*|media_type|pdf/*"
                            multiple="true"
                            class="file-upload"
                        >
                            <ng-template #placeholder let-isFileDragDropAvailable="isFileDragDropAvailable"></ng-template>
                            <ng-template #item let-i="index" let-file="file" let-control="control">
                                <div class="">
                                    <i class="la la-file m--font-inverse-light"></i>
                                    <span class="file-name">{{ file.name }}</span>
                                    <a (click)="control.removeFile(file)" class="float-right">
                                        <i class="la la-times m--font-danger"></i>
                                    </a>
                                </div>
                                @if (isUploading) {
                                    <div class="m-loader m-loader--brand"></div>
                                }
                            </ng-template>
                        </file-upload>
                    </div>
                </form>
            }
        </div>
    </div>
}
